import { exists } from '@/api'

export interface PreferenceAssignCollection {
  id: number
}

export function PreferenceAssignCollectionFromJSON(
  json: any
): PreferenceAssignCollection {
  return {
    id: exists(json, 'id') ? json.id : 0
  }
}
